import React, { useMemo } from 'react'
import UserMenu from 'components/Header/subcomponents/UserMenu'
import TicketsCounter from 'components/Header/subcomponents/TicketsCounter'
import { Button, Grid, Icon } from 'gu-ui-kit'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import PropTypes from 'prop-types'
import styles from 'components/Drawer/drawer.module.scss'
import { useSelector } from 'react-redux'
import { selectAppUser } from 'modules/App/store/selectors'
import { Link } from 'react-router-dom'

const DrawerFooter = ({ collapse }) => {
  const pathGen = useGeneratePathI18n()

  const { is_email_confirmed } = useSelector(selectAppUser)

  const isEmailConfirmed = useMemo(
    () => (typeof is_email_confirmed === 'boolean' ? is_email_confirmed : null),
    [is_email_confirmed],
  )

  return (
    <Grid
      gap={8}
      wrap={false}
      flexDirection={collapse ? 'column' : 'row'}
      flexJustify={'space-between'}
      className={styles['drawer-inner__grid_bottom']}
    >
      <UserMenu className={styles['drawer-footer__button']} />
      <TicketsCounter className={styles['drawer-footer__button']} />
      <Button
        className={styles['drawer-footer__button']}
        component={'a'}
        size={'s'}
        variant={'ghost'}
        grey
        color={'Interface-Eight'}
        startIcon={<Icon name={'question'} />}
        target={'_blank'}
        href={pathGen(ROUTES.FAQ)}
      />

      <div className={styles['drawer-footer__button-wrap']}>
        <Button
          className={styles['drawer-footer__button']}
          component={Link}
          to={pathGen(ROUTES.USER_SETTINGS)}
          size={'s'}
          variant={'ghost'}
          grey
          color={'Interface-Eight'}
          startIcon={<Icon name={'settings'} />}
          noLabel
        />
        {isEmailConfirmed === false && (
          <Icon
            className={'notify-icon'}
            name={'status warning2'}
            size={'s'}
            color={'Accent-Error-Primary'}
          />
        )}
      </div>
    </Grid>
  )
}

export default DrawerFooter

DrawerFooter.propTypes = {
  collapse: PropTypes.bool,
}
